import type { MiAlcance } from '../types/metas.types';

/**
 * El alcance de DIRECCIÓN (21-oct-2026, decisión del usuario: «un rol más
 * directivo con información importante», para Dirección de Operaciones y
 * Dirección General).
 *
 * Una cuenta Indicadores con este alcance VE todas las tiendas del catálogo y
 * nada más: no captura, no autoriza, no reabre ni ve Accesos ni «Bajar
 * autorizadas». La pantalla le pone la pestaña Autorización en sólo lectura
 * («Seguimiento») y el selector de regional que antes era sólo del admin.
 *
 * La seguridad no está aquí: la API responde 403 a cualquier escritura de esta
 * cuenta (`puede()` sólo le da «ver»). Esto sólo decide qué se pinta.
 */

type Alcance = Pick<MiAlcance, 'esAdmin' | 'alcances'> & Partial<Pick<MiAlcance, 'esDireccion' | 'puedeAutorizar'>>;

/** Tiene el alcance de dirección. Una API anterior no manda `esDireccion`: se deduce de `alcances`. */
export const tieneDireccion = (a: Alcance): boolean =>
  !a.esAdmin && (a.esDireccion ?? a.alcances.some((x) => x.tipo === 'direccion'));

/** Ve el catálogo completo (administrador o dirección): elige regional en los filtros. */
export const veTodasLasTiendas = (a: Alcance): boolean => a.esAdmin || tieneDireccion(a);

/**
 * «Seguimiento»: la pestaña Autorización sin decisiones. Dirección que no es
 * además regional; si lo es, ve la Autorización de siempre (con el regional
 * que elija) y sólo resuelve las tiendas de SU regional, como dice la API.
 */
export const soloSeguimiento = (a: Alcance): boolean => tieneDireccion(a) && !a.puedeAutorizar;
